module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Headers'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1), _vm._v(" "), _c('Footers', {
    attrs: {
      "sel": "selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5382b186!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 28
// module chunks = 0